export default __webpack_public_path__ + "static/media/5667 - Niftynaut.280f5f0c.jpeg";